
export const StockOrderTypesEnum = {
    OrderStock: "1",
    ReceiveStock: "2",
    TransferStock: "3",
    ReturnStock: "4",
  };